import * as React from "react";
import PropTypes from "prop-types";
import DateFns from "date-fns";
import { parseAPIDate } from "../lib/dateUtils/dateUtils";

// The phones and browsers that have push switched on, live and stopped.
// Dead rows stay (marked, not deleted) so the office can see "stopped on ...".

function when(iso) {
	if (!iso) return "";
	const d = parseAPIDate(iso);
	return isNaN(d.getTime()) ? "" : DateFns.format(d, "ddd D MMM YYYY, h:mm A");
}

export default class DeviceList extends React.Component {
	render() {
		const { devices, onRemove, busyId, emptyText } = this.props;
		if (!devices.length) {
			return <p className="ns-muted">{emptyText}</p>;
		}
		return (
			<ul className="ns-devices">
				{devices.map(d => (
					<li key={d.id} className={"ns-device" + (d.failed_at ? " dead" : "")}>
						<span className="ns-device-main">
							<b>{d.user_agent || "A browser"}</b>
							<span className="ns-muted">
								{d.failed_at
									? " stopped " + when(d.failed_at)
									: d.last_success_at
									? " last reached " + when(d.last_success_at)
									: " added " + when(d.created_at) + ", nothing sent yet"}
							</span>
						</span>
						<button type="button" className="btn btn-link ns-remove" disabled={busyId === d.id} onClick={() => onRemove(d)}>
							Remove
						</button>
					</li>
				))}
			</ul>
		);
	}
}

DeviceList.propTypes = {
	devices: PropTypes.array.isRequired,
	onRemove: PropTypes.func.isRequired,
	busyId: PropTypes.number,
	emptyText: PropTypes.string.isRequired
};
